import { filtersAccordionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFiltersAccordion";
import AccordionSectionPanel from "@insite/mobius/AccordionSection/AccordionSectionPanel";
import { CheckboxGroupStyle } from "@insite/mobius/CheckboxGroup/CheckboxGroup";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";



filtersAccordionStyles.accordion = {
    css: css`
        margin-top: 30px;
        dd{
            border: 0 ;
            overflow-y: initial;
            overflow-x: initial;
            max-height: unset;
            border-bottom: 1px solid #d3d3d3 !important;
            padding: 15px 15px 0;
            span[role="checkbox"] {
                background-color: ${getColor("common.background")};
                min-width: 18px;
                min-height: 18px;
                margin-top: 2px;
            }
            div[class^="CheckboxGroupStyle"] {
                flex-direction: row;
                padding-bottom: 15px ! IMPORTANT;
            }
        }

        dt{
            border-bottom: 1px solid #d3d3d3 !important;
        }

      
        
        dt {
            &.expandedClass{
                border-bottom: 0 !important;
            }
        }
       
        button {
            padding: 12px 5px !important;
            background-color: ${getColor("common.background")} !important;
            text-transform: uppercase;
            font-weight: 500!important;
            outline: 0 !important;
            border: 0 solid transparent !important;
            > ${TypographyStyle} {
                font-size: 14px !important;
                color: #000;
                font-weight: 500;
            }
            &:focus {
                outline: 0 !important;
                border: 0 solid transparent !important;
            }
        }
        > ${AccordionSectionPanel} {
            border: none;
            margin-bottom: 10px;
            background-color: ${getColor("secondary")};
        }
    `,
};